export function getParticipantSettingsBulkHostTargets(people = []) {
  return people.filter(person => {
    if (!person || person.isMe) {
      return false;
    }

    return !!person.roles?.signed_in && !person.roles?.creator && !person.roles?.owner;
  });
}

export function getParticipantSettingsBulkHostAction({ people = [], allHost = false, canUpdateRoles = false } = {}) {
  return {
    body: "Do you want to make every signed-in guest a host? They will be able to manage the room.",
    disabled: !canUpdateRoles || allHost || getParticipantSettingsBulkHostTargets(people).length === 0,
    label: "Make all hosts",
    title: "Make all hosts"
  };
}

export function getParticipantSettingsMicrophoneAction({ person, allMuted = false, voiceChatEnabled = false } = {}) {
  const isAll = !person;
  const targetMuted = isAll ? allMuted : person?.micPresence?.muted !== false;

  return {
    disabled: !voiceChatEnabled || targetMuted,
    label: isAll ? "Mute everyone" : "Mute"
  };
}

export function getParticipantSettingsHideAction({ person, isHidden = false } = {}) {
  if (!person) {
    return null;
  }

  return {
    disabled: Boolean(person.isMe),
    label: isHidden ? "Unhide" : "Hide"
  };
}

export function getParticipantSettingsMediaShareTargets(people = [], activeOwnerIds = new Set()) {
  return people.filter(person => {
    if (!person || person.isMe || person.presence !== "room" || person.roles?.creator) {
      return false;
    }

    return activeOwnerIds.has(person.id);
  });
}

export function getParticipantSettingsMediaShareAction({ person, source, active = false, targetCount = 0 } = {}) {
  const isScreenShare = source === "screen";
  const isAll = !person;
  const hasTarget = isAll ? targetCount > 0 : active;
  let label;

  if (isAll) {
    label = isScreenShare ? "Stop all screen shares" : "Stop all cameras";
  } else {
    label = isScreenShare ? "Stop screen share" : "Stop camera";
  }

  return {
    disabled: !hasTarget,
    label
  };
}

export function getParticipantSettingsKickTargets(people = []) {
  return people.filter(person => person && !person.isMe && !person.roles?.creator && !person.roles?.owner);
}

export function getParticipantSettingsKickAction({ person } = {}) {
  if (person) {
    return {
      body: `Do you want to kick ${person?.profile?.displayName} from the verse?`,
      buttonLabel: "Kick",
      confirmLabel: "Kick",
      title: "Kick User"
    };
  }

  return {
    body: "Do you want to remove all guests from the verse? Hosts and you will stay in the room.",
    buttonLabel: "Kick guests",
    confirmLabel: "Kick guests",
    title: "Kick guests"
  };
}
